import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { UaService } from '@ecm/consumer';
import { EcmRouterModule, LinkService, RouterService, TrackingData } from '@ecm/router';

import { UniverseEnum } from '../../../../business/api/dashboard/universeEnum';
import { MultiContractViewModel } from '../../../../business/model/crossroads/contracts-options/multi-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { ParamsUtils } from '../../../../utils/params.utils';
import { AbstractComponent } from '../../../shared/abstract.component';

@Component({
    selector: 'multi-contract-item',
    templateUrl: 'multi-contract-item.html',
    styleUrls: ['multi-contract-item.css'],
    standalone: true,
    imports: [AsyncPipe, EcmRouterModule, TranslateModule],
})
export class MultiContractItemComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: ContractsViewModel;

    @Input()
    public borderBottom = true;

    @Input()
    public universe: UniverseEnum;

    public multiContractViewModel: MultiContractViewModel;

    /**
     * GA tracking area
     * @type {string}
     */
    private readonly trackingArea: string = 'care_selecteurcontrat_offre';

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        private readonly translate: TranslateService,
        private readonly linkService: LinkService,
    ) {
        super(uaService, routerService);
        translate.use('fr');
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.viewModel.contract) {
            this.multiContractViewModel = this.viewModel.contract as MultiContractViewModel;
        }
    }

    public getLinkParam(): Map<string, string> {
        return ParamsUtils.cidMap(this.multiContractViewModel.cid);
    }

    /**
     * Open button link for multi contract
     * @param link
     */
    public openMultiContract(link: any): void {
        this.translate.get('dashboard.contractsAndOptions.multiContract').subscribe((multiContract: any) => {
            this.linkService.openLink(
                link,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.contractsAndOptions,
                        trackingArea: this.trackingArea,
                        trackingName: multiContract['button'],
                    },
                }),
                null,
                null,
                false,
            );
        });
    }

    /**
     * Open button link for eSIM activation
     */
    public openButtonESimLink(): void {
        this.translate.get('dashboard.contractsAndOptions.multiContract.parnasse').subscribe((parnasse: any) => {
            this.linkService.openLink(
                this.multiContractViewModel.eSimLink,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.contractsAndOptions,
                        trackingArea: this.trackingArea,
                        trackingName: parnasse['eSimLabel'],
                    },
                }),
                ParamsUtils.cidMap(this.multiContractViewModel.cid),
            );
        });
    }
}
